import React, { useRef } from 'react';

const DISMISS_PX = 96;
const DISMISS_VELOCITY = 0.55; // px/ms

/**
 * Maniglia bottom-sheet: solo swipe verso il basso per chiudere.
 * Non è un bottone di chiusura (per quello usare Chiudi / ✕).
 */
export default function MobileSheetHandle({ onClose }) {
  const startY = useRef(0);
  const startT = useRef(0);
  const dragging = useRef(false);
  const panelEl = useRef(null);

  const getPanel = (el) => el?.closest?.('.mobile-sheet-panel') || null;

  const resetPanel = () => {
    const panel = panelEl.current;
    if (!panel) return;
    panel.style.transition = 'transform 0.2s ease';
    panel.style.transform = '';
  };

  const onPointerDown = (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    const panel = getPanel(e.currentTarget);
    if (!panel) return;
    panelEl.current = panel;
    dragging.current = true;
    startY.current = e.clientY;
    startT.current = Date.now();
    panel.style.transition = 'none';
    try {
      e.currentTarget.setPointerCapture?.(e.pointerId);
    } catch (_) {}
  };

  const onPointerMove = (e) => {
    if (!dragging.current || !panelEl.current) return;
    const dy = Math.max(0, e.clientY - startY.current);
    panelEl.current.style.transform = `translate3d(0, ${dy}px, 0)`;
  };

  const finish = (e) => {
    if (!dragging.current) return;
    dragging.current = false;
    const dy = Math.max(0, e.clientY - startY.current);
    const dt = Math.max(1, Date.now() - startT.current);
    const velocity = dy / dt;
    if (dy >= DISMISS_PX || velocity >= DISMISS_VELOCITY) {
      const panel = panelEl.current;
      if (panel) {
        panel.style.transition = 'transform 0.18s ease';
        panel.style.transform = 'translate3d(0, 110%, 0)';
      }
      window.setTimeout(() => {
        resetPanel();
        onClose?.();
      }, 160);
      return;
    }
    resetPanel();
  };

  return (
    <div
      className="mobile-sheet-handle"
      role="presentation"
      aria-hidden="true"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={finish}
      onPointerCancel={finish}
    />
  );
}
